/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import homeLogo from '../../assets/images/home-main.svg';
import PersonalInfo from '../../components/PersonalInfo/PersonalInfo';
import Type from '../../components/Type/Type';
function AboutMe() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hello !{' '}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> PRASHANTA KUMAR DEY</strong>
                <br />
                <strong className="main-name">
                  （デイプラシェンタクマール）
                </strong>
              </h1>

              <div style={{ padding: 50, textAlign: 'left' }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: '450px' }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <PersonalInfo />
    </section>
  );
}

export default AboutMe;
